import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

/**
 * When user.role === 'Vendor', redirect any non-/partner path to /partner.
 * Vendors never see public pages (/, /group-trips, /shared-rentals, etc.).
 */
function VendorRouteGuard({ currentUser }) {
  const location = useLocation();
  const path = (location.pathname || '').replace(/\/$/, '') || '/';

  if (currentUser?.email !== undefined && currentUser?.role === 'Vendor' && !path.startsWith('/partner')) {
    return <Redirect to="/partner" replace />;
  }
  return null;
}

const mapStateToProps = ({ userStore }) => ({
  currentUser: userStore?.currentUser || {},
});

export default connect(mapStateToProps)(VendorRouteGuard);
